import { render, staticRenderFns } from "./EmployerServiceLogList.vue?vue&type=template&id=63e55cf4&"
import script from "./EmployerServiceLogList.vue?vue&type=script&lang=ts&"
export * from "./EmployerServiceLogList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports